// src/components/EventView.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { hasBlocksData } from '@plone/volto/helpers/Blocks/Blocks';
import { flattenHTMLToAppURL } from '@plone/volto/helpers/Url/Url';
import { Container as SemanticContainer } from 'semantic-ui-react';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import config from '@plone/volto/registry';

const EventTextfieldView = ({ content }) => {
  const Image = config.getComponent({ name: 'Image' }).component;
  return (
    <>
      {content.title && <h1 className="documentFirstHeading">{content.title}</h1>}
      {content.description && <p className="documentDescription">{content.description}</p>}
      {content.preview_image && (
        <Image
          className="document-image ui right floated image"
          item={content}
          imageField="preview_image"
          alt=""
        />
      )}
      {content.text && (
        <div
          dangerouslySetInnerHTML={{ __html: flattenHTMLToAppURL(content.text.data) }}
        />
      )}
    </>
  );
};

export default function EventView(props) {
  const { content } = props;
  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;

  const language = content.language?.token || 'default';
  const start = content.start ? new Date(content.start) : null;
  const end = content.end ? new Date(content.end) : null;
  const isOpenEnd = !!content.open_end;

  const fmt = new Intl.DateTimeFormat(language, { year: 'numeric', month: 'long', day: 'numeric' });
  const dateText = !end || isOpenEnd ? (start ? fmt.format(start) : '') : fmt.formatRange(start, end);

  return (
    <Container id="page-document" className="view-wrapper event-view">
      <div className="dates">
        {dateText ? <span className="day" suppressHydrationWarning>{dateText}</span> : null}{' '}
        {content?.head_title && <span className="head-title">{content.head_title}</span>}
      </div>

      {hasBlocksData(content) ? <RenderBlocks {...props} /> : <EventTextfieldView content={content} />}
    </Container>
  );
}

EventView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({ data: PropTypes.string }),
    start: PropTypes.string,
    end: PropTypes.string,
    open_end: PropTypes.bool,
  }).isRequired,
};
